import React, { FC, useEffect } from 'react';

import { BaseConfirmDialog } from '../BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from '../BaseConfirmDialog/BaseConformationDialog.types';
import styles from './CreateCopyOfNonEditableFileModal.css';
import { ContentComponent } from './helper';
import { sendTechAnalytics, TechAnalyticsType } from './sendTechAnalytics';
import { CreateCopyOfNonEditableFileModalProps } from './types';
import { useCreateCopyOfFile } from './useCreateCopyOfFile';

export const CreateCopyOfNonEditableFileModal: FC<CreateCopyOfNonEditableFileModalProps> = ({
    file,
    convertedStorage,
    fromSharePopup = false,
    onClose,
}) => {
    const convertExtension = file.subKind === 'text' ? 'DOCX' : 'XLSX';
    const isSharedFile = !!file.weblink || fromSharePopup;

    const techAnalytics = sendTechAnalytics(file.ext, convertedStorage);

    const handleCreateCopyOfFile = useCreateCopyOfFile({ isSharedFile, file, convertedStorage, fromSharePopup, onClose, techAnalytics });

    useEffect(() => {
        techAnalytics(TechAnalyticsType.showPopup);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <BaseConfirmDialog
            onClose={onClose}
            renderHeader={() => (
                <div className={styles.header}>{isSharedFile ? 'Создайте копию для\u00A0редактирования' : 'Создайте копию документа'}</div>
            )}
            renderContent={() => (
                <ContentComponent fromSharePopup={fromSharePopup} isSharedFile={!!file.weblink} convertExtension={convertExtension} />
            )}
            buttons={[EButtonType.accept]}
            successButtonText="Создать копию"
            onSuccess={handleCreateCopyOfFile}
        />
    );
};
